import {
  getToken,
  onMessage,
  isSupported,
  getMessaging,
} from 'firebase/messaging'
import { pushToken } from '@/redux/store/actions/firebaseAction'
import { GET_PUSH_NOTIFICATION } from '@/redux/store/actions/types'
import { setCookie } from './props'
import { FirebaseApp } from 'firebase/app'
import intrack from './intrack'

interface handleFirebaseMessagingArgs {
  dispatch: any
  registeration: ServiceWorkerRegistration
  app: FirebaseApp
}

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyAwgPp7jH7O7r0AczGPu7UN_pU0yKnQ_Lk',
  authDomain: 'shab-163306.firebaseapp.com',
  databaseURL: 'https://shab-163306.firebaseio.com',
  projectId: 'shab-163306',
  storageBucket: 'shab-163306.appspot.com',
  messagingSenderId: '9406792910',
  appId: '1:9406792910:web:75876bee0fbe02d5a4fc9f',
  measurementId: 'G-5MZJRDTX36',
}

export const handleFirebaseMessaging = async ({
  dispatch,
  registeration,
  app,
}: handleFirebaseMessagingArgs) => {
  try {
    const supported = await isSupported()
    if (supported) {
      const messaging = getMessaging(app)
      const token = await getToken(messaging, {
        vapidKey:
          'BOpCXZoNJYU_yH1Y2XgmBhu1aRodqEYV1ReyABLHSWOnDpRSGCYiXo36tkmmJfldfjIo7OqZC5IC2QLcg8doVLI',
        serviceWorkerRegistration: registeration,
      })

      if (token) {
        setCookie('fb-token', token, 30)
        dispatch(pushToken(token))
        intrack?.webPush(token)
      }

      onMessage(messaging, payload => {
        if (payload?.data) {
          if (payload?.data?.source === 'inTrack') {
            return
          } else {
            dispatch({
              type: GET_PUSH_NOTIFICATION,
              data: payload.data,
              show: true,
            })
          }
        }
      })
    } else {
      console.log('مرورگر شما از Firebase Messaging پشتیبانی نمی‌کند.')
    }
  } catch (error) {
    console.log('Error in handleFirebaseMessaging:', error)
  }
}
